<template>
	<div class="student-list">
		<student 
			:student="student"
			:isCollapsed="isCollapsed"
			v-for="(student) in otherStudents" 
			:key="student.STUDENT_RID"
		>
		</student>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Student from './Student.vue';
export default {
	props: {
		isCollapsed: false,
	},
	computed: {
		...mapGetters([
			'selectedStudent'
		]),
		...mapState([
			'students','selectedStudentRID'
		]),
		otherStudents(){
			return this.students.filter( s => s.STUDENT_RID !== this.selectedStudentRID );
		}
	},
	components: {
		Student
	}
}
</script>
